import { getRisksService } from '@/services/modules/health-tracker/v2/common/selectors/risks/risks-service'

const state = () => ({
    risks: []
})

const mutations = {
    SET_RISKS (state, values) {
        state.risks = values
    }
}

const actions = {
    async getRisksAction ({ commit }) {
        const { result } = await getRisksService()
        commit('SET_RISKS', result)
    }
}
const getters = {
    getRisksGetter: (state) => { return state.risks }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}